<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-3">
        <BranchStatsPanel />
      </div>
      <!-- end col -->
      <div class="col-xl-9">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create Teller</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateTellerForm></CreateTellerForm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Create Teller",
    meta: [{ name: "Create Teller", content: window.__env.app.description }]
  },

  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreateTeller",
      title: "Create Teller",
      items: [
        {
          text: "Teller",
          href: "/"
        },
        {
          text: "Create Teller",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
